/*
 * Preview Grid + item
 * Base copied from preview-carousel.js
 * Version: 1.1.0
 *
 * Also handles stand alone preview items.
 */

ckdc.ready( function( $ ) {
    // main ckdc object required
    if ( typeof ckdc == 'undefined' ) {
		return;
    }

    var previewListCounter = 0;
    var previewItemCounter = 0;

    function mouseEnterItem(e) {
	var item = $(e.currentTarget);

	var links = item.find("a");
	links.attr("title", "");

	itemEnterHandler(item);
    }

    function itemEnterHandler(item) {
	ckdc.preview.extraImagesHandling(item);
	item.addClass("selected");
	item.one("mouseleave", function(e) {
	    var item = $(e.currentTarget);
	    item.removeClass("selected");
	});
    }

    /*
     * Setup
     */

    ckdc.setup.addSetupContent( 'preview-grid', setupContent );

    function setupContent( newContent ) {
	var newPreviewGrids = newContent.find(".preview-list.grid:not(.init)");

	newPreviewGrids.each(function() {
	    setupPreviewGrid(this);
	});

	// Set up any items with extra images NOT inside grid or carousel.
	var items = newContent.find( ".preview-item:has(.extra-images-container):not(.init)" );

	items.each( function() {
	    $i = $( this );
	    if ( ! $i.parents( '.preview-list' ).length ) {
		setupPreviewItem( $i );
	    }
	});
    }

    function setupPreviewGrid(grid) {
	var previewGrid = $( grid );

	previewListCounter++;
	previewGrid.attr("id", "preview-list-grid-" + previewListCounter);

	if ( ! ckdc.isMobile ) {
	    //add event handler for the preview items
	    previewGrid.on( "mouseenter", ".preview-item", mouseEnterItem );
	}
	previewGrid.addClass("init");
    }

    function setupPreviewItem( previewItem ) {
	previewItemCounter++;
	previewItem.attr( "id", "preview-item-" + previewItemCounter );

	if ( ! ckdc.isMobile ) {
	    //add event handler for the preview items
	    previewItem.on( "mouseenter", mouseEnterItem );
	}
	previewItem.addClass("init");
    }
});
